/**
 * @file Allow using app feature flags
 */
import environment from '@@/bits/environment'
import window from '@@/bits/global'
import { isStringTruthy } from '@@/bits/truthy'

type CurrentFlags =
  | 'debugFrontend'
  | 'goldPlansVisible'
  | 'managePeopleV2'
  | 'aiImageSearch'
  | 'googleDrive'
  | 'accumulatedReactions'
  | 'realtimeFetching'
  | 'brahmsCheck'
  | 'surfaceGroupByPanel'
  | 'reportButton'
  | 'magicPadlet'
  | 'zoom'
  | 'spreadsheetExportsV2'
  | 'remakeSettingV2'
  | 'showCommandPalette'
  | 'publicApi'
  | 'autoContentModeration'
  | 'changeEmailVerification'
  | 'loginEmailVerificationWarning'
  | 'signupEmailVerification'
  | 'dashboardSetting'
  | 'surfaceCommentsV2'
  | 'universalPostEditor'
  | 'onboardingPanel'
  | 'galleryTemplates'
  | 'dragAndDropV2'
  | 'layoutFormatSettingV2'
  | 'userGroups'
  | 'templates'
  | 'templatesWithNewSidebar'
  | 'classlinkSso'
  | 'surfacePdfExportPanelV2'
  | 'sectionBreakout'
  | 'surfacePostProps'
  | 'surfacePostPropsColor'
  | 'surfacePostPropsLocation'
  | 'surfacePostPropsSubjectAttachmentBody'
  | 'surfacePostPropsCustomTextField'
  | 'surfacePostPropsAttachmentSettings'
  | 'submissionRequest'
  | 'editThumbnail'
  | 'virtualizedDashboard'
  | 'tenantContentSafetySettings'
  | 'commentModeration'

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const ww = window.ww || {}
  const flip = ww.flip || ww.vueStartingState?.flip || {}
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

export const isDebugMode =
  environment === 'development' ||
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  isStringTruthy(new URLSearchParams(window.location.search).get('ww_debug'))

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

export { isAppUsing }
